var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg007Equalizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.5,406.122c-11.046,0-20,8.954-20,20V492c0,11.046,8.954,20,20,20s20-8.954,20-20v-65.878 C216.5,415.076,207.546,406.122,196.5,406.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5,326h-20V20c0-11.046-8.954-20-20-20s-20,8.954-20,20v306h-20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h80 c11.046,0,20-8.954,20-20C256.5,334.954,247.546,326,236.5,326z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5,144.122c-11.046,0-20,8.954-20,20V492c0,11.046,8.954,20,20,20s20-8.954,20-20V164.122 C80.5,153.076,71.546,144.122,60.5,144.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,64.244h-20V20c0-11.046-8.954-20-20-20s-20,8.954-20,20v44.244h-20c-11.046,0-20,8.954-20,20 c0,11.046,8.954,20,20,20h80c11.046,0,20-8.954,20-20C120.5,73.198,111.546,64.244,100.5,64.244z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.5,171.168c-11.046,0-20,8.954-20,20V492c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V191.168 C471.5,180.122,462.546,171.168,451.5,171.168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.5,91.122h-20V20c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v71.122h-20c-11.046,0-20,8.954-20,20 c0,11.046,8.954,20,20,20h80c11.046,0,20-8.954,20-20S502.546,91.122,491.5,91.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,318.122c-11.046,0-20,8.954-20,20V492c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V338.122 C341.5,327.076,332.546,318.122,321.5,318.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,238.244h-20V20c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v218.244h-20c-11.046,0-20,8.954-20,20 s8.954,20,20,20h80c11.046,0,20-8.954,20-20C381.5,247.198,372.546,238.244,361.5,238.244z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg007Equalizer);
export default __webpack_public_path__ + "static/media/007-equalizer.6b6290e83a7ae3e604f6e4973f1ca7d5.svg";
export { ForwardRef as ReactComponent };